import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const FlowAI: FunctionComponent = () => {
	const {t} = useTranslation();
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'flowlandingpage_title_powerofartificialintelligence_standalone-web',
							{ns: 'flow'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'flowlandingpage_text_powerofartificialintelligence_standalone-web',
							{ns: 'flow'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					src="027f79c4821f603a4fffe1018c37c43e.png"
					aspectRatio="2048/654"
					alt={t('imagemetatag_text_AImusicgenerator_standalone-web', {
						ns: 'common',
					})}
				/>
			}
			/*
			 * Disable the CTA for now as medium content on deezer.io is shutdown
			cta={
				<LandingButtonLink
					tracking={{
						eventaction: 'read-article',
						eventlabel: 'discover-flow-mood',
					}}
					target="_blank"
					href="https://deezer.io/tagged/artificial-intelligence"
				>
					{t('generic_action_learnmore_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
			*/
		/>
	);
};
